import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLeadSummary as GetLeadSummaryQuery,
    GetLeadSummaryVariables as GetLeadSummaryVariables,
    GetLeadSummary_lead as Lead,
} from 'nutshell-graphql-types';

import GET_LEAD_SUMMARY from '../queries/get-lead-summary.graphql';

export const useGetLeadSummary = (
    id?: string | null,
    number?: number | null,
    skip: boolean = false
): {
    leadSummary: Lead | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetLeadSummaryQuery, GetLeadSummaryVariables>(
        GET_LEAD_SUMMARY,
        {
            variables: {
                id,
                number,
            },
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    return {
        leadSummary: data && data.lead,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
